import PropTypes from 'prop-types'

import { Table, Tooltip } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useTheme } from 'react-jss'

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

const getTextOrDefaultToDash = text => text || '\u2014'

const LEAD_PROP_TYPES = {
  modelNumber: PropTypes.string,
  manufacturer: PropTypes.string,
}

export default function LeadInfo({ currentLead = {}, currentDevice = {} }) {
  const theme = useTheme()
  const { rightAtrium, rightVentricle, leftVentricle } = currentLead || {}
  const { modelName, modelManufacturer, warning: deviceWarning } = currentDevice || {}

  const COLUMNS = [
    {
      dataIndex: ['name'],
      key: 'name',
      width: 120,
      render: text => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: 'Company',
      dataIndex: ['manufacturer'],
      key: 'manufacturer',
      align: 'center',
      render: getTextOrDefaultToDash,
    },
    {
      title: 'Model #',
      dataIndex: ['modelNumber'],
      key: 'modelNumber',
      align: 'center',
      render: getTextOrDefaultToDash,
    },
    {
      title: 'Advisory / Recall',
      dataIndex: ['warning'],
      key: 'warning',
      align: 'center',
      render: (_, data) => {
        if (!data?.warning) return ''

        return (
          <span>
            <Tooltip title={`${capitalize(data.warning.type)}: ${data.warning.description}`}>
              <WarningOutlined style={{ color: theme.brandDangerMid }} />
            </Tooltip>
          </span>
        )
      },
    },
  ]

  const data = [
    { name: 'Right Atrium', ...rightAtrium },
    { name: 'Right Ventricle', ...rightVentricle },
    { name: 'Left Ventricle', ...leftVentricle },
    { name: 'Device', modelNumber: modelName, manufacturer: modelManufacturer, warning: deviceWarning}
  ]
  return (
    <Table
      bordered
      columns={COLUMNS}
      dataSource={data}
      pagination={false}
      size="small"
      rowKey="name"
      style={{ borderRadius: 6, overflow: 'hidden' }}
    />
  )
}

LeadInfo.propTypes = {
  currentLead: PropTypes.oneOfType([
    PropTypes.shape({
      rightAtrium: PropTypes.shape(LEAD_PROP_TYPES),
      rightVentricle: PropTypes.shape(LEAD_PROP_TYPES),
      leftVentricle: PropTypes.shape(LEAD_PROP_TYPES),
    }),
    PropTypes.object,
  ]),
  currentDevice: PropTypes.shape({}),
}
